export default "__VITE_ASSET__CxoPbZKD__"